<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="pt-3">
  <div class="row mb-2">
    <div class="col-md-6">
      <div class="dropdown">
        <h4>Paper Submissions</h4>
      </div>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col">
      <div class="row">
        <div class="col-md-12">
          <div class="card p-0">
            <div class="card-body p-0">
              <div class="row">
                <div class="col-md-12">
                  <table class="table table-hover">
                    <thead class="bg-light">
                      <tr>
                        <th>Title</th>
                        <th>Type</th>
                        <th>Conference</th>
                        <th>Submitted By</th>
                        <th>Status</th>
                        <th class="text-right">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let paper of papers">
                        <td>
                          <a [routerLink]="['/', paper.conferenceSlug, 'call-for-papers']" [queryParams]="{ paperId: paper.id }">{{ paper.title }}<span *ngIf="!paper.title">&lt;No Title&gt;</span></a>
                        </td>
                        <td>{{ paper.paperTypeName }}</td>
                        <td>{{ paper.conferenceName }}</td>
                        <td>{{ paper.submittingUser.firstName + ' ' + paper.submittingUser.lastName }}</td>
                        <td>{{ paper.paperApprovalStatus }}</td>
                        <td>
                          <div class="dropdown text-right">
                            <button class="btn btn-xs btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                              <a class="dropdown-item" [routerLink]="['/', paper.conferenceSlug, 'call-for-papers']" [queryParams]="{ paperId: paper.id }">Edit</a>
                              <a  *ngIf="paper.paperApprovalStatus.toString() == 'Draft'" class="dropdown-item" href="javascript:void(0)" (click)="delete(paper)">Delete</a>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
